import { gql } from '@apollo/client'
import Mail from 'globals/models/Mail'

export const MARK_MAILS_AS_REDIRECTED = gql`
  mutation markUserMailsAsRedirected($userMailIds: [ID!]!) {
    markUserMailsAsRedirected(userMailIds: $userMailIds) {
      userMails {
          id
          mailType
          createdAt
          dateOfReceipt
          forwardedAt
          physicalLocation
          physicallyDestroyedAt
          processingType
          processingDate
          provisionedAt
          queryDate
          scanFile
          scannedAt
          sendName
          weight
        }
    }
  }
`

export interface MarkMailsAsRedirectedVariables {
  userMailIds: number[]
}

export interface MarkMailsAsRedirectedResult {
  userMails: Mail[]
}

export const MARK_MAILS_AS_DESTROYED = gql`
  mutation markUserMailsAsDestroyed($userMailIds: [ID!]!) {
    markUserMailsAsDestroyed(userMailIds: $userMailIds) {
      userMails {
          id
          mailType
          createdAt
          dateOfReceipt
          forwardedAt
          physicalLocation
          physicallyDestroyedAt
          processingType
          processingDate
          provisionedAt
          queryDate
          scanFile
          scannedAt
          sendName
          weight
        }
    }
  }
`

export interface MarkMailsAsDestroyedVariables {
  userMailIds: number[]
}

export interface MarkMailsAsDestroyedResult {
  userMails: Mail[]
}
